module.exports = __webpack_public_path__ + "static/media/135.bd31ebf7.jpg";